





























import { Component, Prop, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import { drawRoute } from '@/services/city-marker.service';
import { MapStore } from '@/store/map';

@Component
export default class MapBoxControls extends Vue {
  @Prop({ required: true }) readonly isMobileDevice: boolean;

  isFullScreen = false;
  isDefaultStyle = true;
  private _mapStore!: MapStore;

  created() {
    this._mapStore = getModule(MapStore, this.$store);
  }

  fullScreen() {
    if (this.isFullScreen) document.exitFullscreen();
    else document.body.requestFullscreen();

    this.isFullScreen = !this.isFullScreen;
  }

  changeStyle() {
    const style = this.isDefaultStyle ? process.env.VUE_APP_MAPBOX_STYLE_SECOND : process.env.VUE_APP_MAPBOX_STYLE;

    this._mapStore.map.setStyle(style, { diff: false });

    this.isDefaultStyle = !this.isDefaultStyle;

    this._mapStore.map.once('styledata', () => {
      this._mapStore.updateSources();
      this._mapStore.updateLayers();
    });

    if (this._mapStore.selectedCityMarkerId) {
      drawRoute();
    }
  }

  zoomIn() {
    this._mapStore.zoomIn();
  }

  zoomOut() {
    this._mapStore.zoomOut();
  }
}
